<template>
    <header class="header header--main">
        <TitleBar></TitleBar>
        <div class="header__blocks">
            <div class="header__block header__block--content">
                <nav class="nav nav--primary">
                    <ul>
                        <li>
                            <a href="#key_developments">Key Developments</a>
                        </li>
                        <li>
                            <a href="#how_to_give">How to Give</a>
                        </li>
                        <li>
                            <a href="#faqs">FAQs</a>
                        </li>
                    </ul>
                </nav>
                <div class="campaign-logo">
                    <img src="../assets/3_by_23.svg" alt="3 by 23" />
                </div>
                <div class="header__block__text">
                    <h1>Let’s Make it Happen</h1>
                    <h3>
                        We’re on a mission to raise €3M by 2023 for some
                        <br />exciting developments and we need your help!
                    </h3>
                    <ButtonLink
                        icon="give"
                        title="How to Give"
                        link="#how_to_give"
                    ></ButtonLink>
                </div>
            </div>
            <div
                class="header__block header__block--video"
                @click="modalTrigger"
            >
                <video loop muted autoplay poster="../assets/hero.jpg">
                    <source src="../assets/kilkenny-college.mp4" />
                </video>
                <div class="header__block__controls">
                    <div class="icon icon-icon-play"></div>
                    <h6>Play Video</h6>
                </div>
                <div class="header__block--video_footnote">
                    The following footage was filmed before the Covid-19
                    outbreak.
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import TitleBar from "@/components/TitleBar.vue"
export default {
    components: {
        TitleBar,
    },

    methods: {
        slowMo() {
            const vid = this.$refs.headerVideo
            vid.playbackRate = 0.5
        },
        modalTrigger() {
            this.$root.$emit("modalOpen")
        },
    },
}
</script>

<style lang="scss" scoped>
nav {
    width: 100%;
    padding-right: 1.5rem;
    position: absolute;
    top: 0.4rem;
    left: 0;

    @include tablet-and-mobile {
        display: none;
    }

    ul {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        flex-direction: row;
        padding-top: 1.5rem;

        list-style: none;

        a {
            color: var(--quaternary_colour);
            font-size: 0.875rem;
            font-weight: 600;
            text-decoration: none;
            margin-right: 1.5rem;
            text-transform: uppercase;
        }
    }
}

.header--main {
    color: white;
    background-color: var(--primary_colour);

    @include tablet-and-mobile {
        padding-top: 5rem;
    }

    h1 {
        font-size: 3.375rem;
        margin-bottom: 1.5rem;
    }

    h3 {
        margin-bottom: 2rem;
        font-size: 1.25rem;
        line-height: 1.875rem;

        br {
            display: block;

            @include mobile {
                display: none;
            }
        }
    }
}

.header__blocks {
    @include gridBlock();
    // set min width of left panel so links don't
    // get hidden behind logo
    grid-template-columns: minmax(675px, 1fr) 1fr;

    @include iego {
        justify-content: center;
        flex-wrap: nowrap;
    }

    @include tablet-and-mobile {
        display: block;
    }
}

.header__block {
    position: relative;

    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        opacity: 0.4;
    }
}

.header__block {
    &__controls {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        flex-direction: column;
        transition: opacity 0.5s ease;

        &:hover {
            cursor: pointer;
            opacity: 0.3;
        }

        .icon {
            font-size: 5rem;
        }

        h6 {
            text-transform: uppercase;
            font-size: 1rem;
            font-weight: 700;
            margin-top: 1.5rem;
        }
    }

    @include iego {
        margin: 0 !important;
    }

    &__text {
        padding: 4rem;

        @include mobile {
            padding: 4rem 2rem;
        }
    }
}

.header__block--content {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-start;

    .button_link {
        display: inline-flex;
    }
}

.header__block--video {
    background-color: black;
    line-height: 0;

    &_footnote {
        position: absolute;
        bottom: 1em;
        right: 1em;
        line-height: 1.3;
        font-size: 0.75rem;
        text-align: right;
    }
}

.campaign-logo {
    width: 100%;
    margin-top: calc(var(--banner_height) + 3.5rem);

    img {
        min-width: 100%;
    }
}
</style>
